<div class="non-blend" [class.hidden-vert]="!isVisible" aria-label="Toggle" (click)="showHideSecondaryHeader()">
	<button class="icon-btn" [class.active]="isVisibleSecondary" aria-label="Toggle menu"  aria-label="Toggle">
	  <svg
	    class="hamburger"
	    viewBox="0 0 100 100"
	    width="40"
	  >
	    <line class="line top" x1="10" y1="30" x2="90" y2="30" />
	    <line class="line middle" x1="10" y1="50" x2="90" y2="50" />
	    <line class="line bottom" x1="10" y1="70" x2="90" y2="70" />
	  </svg>
	</button>

	<div class="header-button-box" [class.hidden-horizontal]="!isVisibleSecondary">
		<div class="button" ><a [routerLink]="['/menu']">Menu</a></div>
		<div class="button"><a [routerLink]="['/peking-duck-meal-kit']">Meal Kit</a></div>
		<div class="button"><a [routerLink]="['/contact']">Contact</a></div>
		<div class="button"><a href="https://instagram.com/thatpekingduckguy" target="blank" class="fa fa-instagram"></a></div>
	</div>

</div>

<div class="header" [class.blend]="blendMode" [routerLink]="['/']">
	<img class="header-image" src="/static/tpdg/home/That-Peking-Duck-Guy-Combined-Logo-Orange.webp"/>
</div>


<router-outlet></router-outlet>

<div class="footer" >
	<div class="sub-footer">

		<div class="unit row"><a [routerLink]="['/menu']">Menu</a></div>
		<div class="unit row"><a [routerLink]="['/contact']">Contact</a></div>

		<div class="unit row"><a href="https://instagram.com/thatpekingduckguy" target="blank" class="fa fa-instagram"></a></div>

	</div>

	<div class="sub-footer">
		<div class="unit">&#169; That Peking Duck Guy</div>
	</div>

	<div class="sub-footer">
		<div class="unit">Privacy Policy</div>
	</div>

</div>
